import React, { useState } from 'react';
import {Select, Typography, Row, Col, Avatar, Card} from 'antd';
import moment from 'moment';
import Loader from './loader'

import {useGetCryptoNewsQuery} from '../service/cryptoNewsApi'
import {useGetCryptosQuery} from '../service/cryptoApi'

const {Title, Text} = Typography;
const {Option} = Select;

const demoImage = 'https://www.bing.com/th?id=OVFT.mpzuVZnv8dwIMRfQGPbOPC&pid=News'

const News = ({simplified}) => {
    const count = simplified ? 6 : 12;
    const [newsCategory, setNewsCategory] = useState('Cryptocurrency')
    const {data: cryptosList} = useGetCryptosQuery(100);
    const {data: cryptoNews, isLoading} = useGetCryptoNewsQuery({newsCategory, count})
    
    if(isLoading) return <Loader />;
    return (
        <>
        {!simplified && <Title level={3}>Crypto News</Title>}
          <Row gutter={[24, 24]}>
            {!simplified && (
                <Col span={24}>
                    <Select
                        showSearch
                        ClassName="select-news"
                        placeholder= "Select-Cryptocurrency"
                        optionFilterProp="children"
                        onChange={value => setNewsCategory(value)}
                        filterOption={false}
                    >
                        <Option value="Cryptocurrency">Crypto Currencies</Option>
                        {cryptosList?.data?.coins.map(coin => <Option key={coin.name} value={coin.name}>
                            <>
                            <Avatar size='small' style={{ background: "#10899e" }}>{coin.name[0]}</Avatar>{" "}
                                {coin.name}      
                            </>
                        </Option>)}
                    </Select>
                </Col>
            )
            }
            {cryptoNews?.value.map((news, i) => (
                <Col xs={24} sm={12} key={i}>
                    <Card hoverable className="news-card">
                        <a href={news.url} target="_blank" rel="noreferrer">
                            <div className="news-image-container">
                                <Title classname="news-title" level={4}>{news.name}</Title>
                                <img style={{borderRadius: '5px'}} src={news?.image?.thumbnail?.contentUrl || demoImage}  alt={news.name}/>
                            </div>
                            <p>
                                {news.description > 100 ?
                                    `${news.description.substring(0, 100)}...`
                                    : news.description
                                }
                            </p>
                            <div className="provider-container">
                                <div>
                                    <Avatar src={news?.provider[0]?.image?.thumbnail?.contentUrl || demoImage} alt="Chaudhary"/>
                                    <Text className="provider-name">{news?.provider[0]?.name}</Text>
                                </div>
                                    <Text>{moment(news.datePublished).startOf('ss').fromNow()}</Text>
                            </div>
                        </a>
                    </Card>
                </Col>
            ))

            }
        </Row>  
        </>
    )
}

export default News
